import React from 'react'
import Navbar from '../../Navbar/Navbar'
import Footer from '../../Footer/Footer'
import './contact.css'

export default function contact() {
  return (
    <div>
      <Navbar />
      <div className='banner'>
        <div className="banner-content">
            <h1>CONTACT</h1>
            <p>
                HOME | SUPPORT | CONTACT
            </p>
        </div>
      </div>
      <div className="contact-cards">
        <div className="contact-card">
            <div className="icon">
                <i class="fa-solid fa-phone"></i>
            </div>
            <div className="head">
                Phone Number
            </div>
            <div className="card-content">
                +91-45612-51623 <br />
                +91-56123-65498
            </div>
        </div>
        <div className="contact-card">
            <div className="icon">
                <i class="fa-regular fa-envelope"></i>
            </div>
            <div className="head">
                Email Address
            </div>
            <div className="card-content">
            info@gmail.com <br />
            example@gmail.com
            </div>
        </div>
        <div className="contact-card">
            <div className="icon">
            <i class="fa-solid fa-location-dot"></i>
            </div>
            <div className="head">
                Office Address
            </div>
            <div className="card-content">
                1840 E Gravey Avenue Street
            </div>
        </div>
      </div>
      <div className="form">
        <div className="form-head">
            Get in Touch!
        </div>
        <div className='inp'>
            <div className="box"><input type="text" placeholder='Your name' required/></div>
            <div className="box"><input type="text" placeholder='Email Address'/></div>
        </div>
        <div className='inp'>
            <div className="box"><input type="text" placeholder='Phone number' required/></div>
            <div className="box"><input type="text" placeholder='Subject' required/></div>
        </div>
        <div className="inp">
            <div className='msg'>
                <input type="text" placeholder='Type your message' />
            </div>
        </div>
        <input type="submit" value="Submit" />
      </div>
      <Footer />
    </div>
  )
}